import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { TimeWindowDtoUtil, type TimeWindowDto } from '~/model'
import { Section } from './Section'

type Props = {
  // data:
  selectedTimeWindow?: TimeWindowDto
  timeWindows: TimeWindowDto[]
  // config:
  expanded: boolean
  showNoDateLabel: boolean
  // events:
  onToggleExpand: (expand: boolean) => void
  onSelectTimeWindow: (selectedTimeWindow: TimeWindowDto) => void
}

export const TimeWindowSelector = ({
  selectedTimeWindow,
  timeWindows,
  expanded,
  showNoDateLabel,
  onToggleExpand,
  onSelectTimeWindow,
}: Props) => {
  const { t } = useTranslation()
  const valueLabel = selectedTimeWindow ? TimeWindowDtoUtil.format(selectedTimeWindow) : 'Maak een keuze'

  return (
    <Section
      title={t('chooseTime')}
      valueLabel={valueLabel}
      isValid={!!selectedTimeWindow}
      sm={false}
      isRightSection
      expanded={expanded}
      onToggleExpand={onToggleExpand}
    >
      {showNoDateLabel && (
        <Typography variant="body2" sx={({ palette: { grey } }) => ({ margin: 2, color: grey[500] })}>
          {t('specifyPickupDate')}
        </Typography>
      )}
      <Grid container sx={{ padding: 2 }}>
        {timeWindows.map((tw) => {
          const formattedTimeWindow = TimeWindowDtoUtil.format(tw)
          const selected = TimeWindowDtoUtil.equals(tw, selectedTimeWindow)
          return (
            <Grid
              data-test="time-window"
              key={formattedTimeWindow}
              sx={({ palette: { grey } }) => ({
                borderRadius: '3px',
                border: `solid 2px ${grey[400]}`,
                padding: '12px 19px',
                marginRight: 1,
                marginBottom: 1,
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: grey[300],
                },
                ...(selected
                  ? {
                      borderColor: 'common.black',
                      color: 'common.black',
                      cursor: 'default',
                      backgroundColor: grey[300],
                    }
                  : {}),
              })}
              onClick={() => onSelectTimeWindow(tw)}
            >
              <Typography variant="body2">{formattedTimeWindow}</Typography>
            </Grid>
          )
        })}
      </Grid>
    </Section>
  )
}
